import { JetView } from 'webix-jet';

/**
 * TutorialsView class extends JetView to create a view for displaying tutorials.
 */
export default class TutorialsView extends JetView {
    /**
     * Configures the view with specific settings and event handlers.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        return {
            css: 'ifr_template', // CSS class for styling the iframe
            view: 'iframe', // Specifies that the view is an iframe
            on: {
                /**
                 * Event handler triggered after the iframe has loaded.
                 */
                onAfterLoad() {
                    try {
                        // Hides specific elements in the loaded iframe content
                        this.getWindow().document.querySelector('.global-header').style.display = 'none';
                        this.getWindow().document.querySelector(
                            '.section-info-row.section-info-row-get-start',
                        ).style.display = 'none';
                        this.getWindow().document.querySelector('.global-footer-wrap').style.display = 'none';
                    } catch (err) {
                        // Error handling for potential issues in accessing iframe content
                    }
                    if (this.hideProgress) this.hideProgress(); // Hides the progress indicator if it exists
                    this.enable(); // Enables the view after loading
                },
            },
        };
    }

    /**
     * Initializes the view by extending it with a progress bar and loading content.
     * @param {Object} view - The view instance to initialize.
     */
    init(view) {
        webix.extend(view, webix.ProgressBar); // Extends the view with a progress bar functionality
        view.disable(); // Disables the view initially
        view.showProgress({ type: 'icon' }); // Shows a progress indicator of type 'icon'
        view.load('https://webix.com/tutorials/'); // Loads the tutorials content into the iframe
    }
}

// FILE DOCUMENTED
